module.exports = __webpack_public_path__ + "img/disney_logo@2x.d1e2d2db.png";